export default [
  {
    code: 'top',
    isShow: false,
    isMenuDisplaySetting: false,
    requirement: 'top',
    label: 'トップ',
    url: 'top',
    icon: 'home',
    children: []
  },
  {
    code: 'dashboard',
    isShow: false,
    isMenuDisplaySetting: true,
    requirement: 'dataset_id_list',
    label: 'ダッシュボード',
    url: 'dashboard',
    icon: 'svguse:icons/ic_dashboard.svg#ic_dashboard',
    children: []
  },
  {
    code: 'settings',
    isShow: false,
    isMenuDisplaySetting: true,
    label: '監視・設定',
    icon: 'svguse:icons/ic_status_normal.svg#ic_status_normal',
    url: null,
    isDefaultOpenChildren: true,
    children: [
      {
        code: 'graphic',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'graphic_tab_setting',
        label: 'グラフィック',
        icon: 'svguse:icons/graphic.svg#graphic',
        url: 'graphic',
      },
      {
        code: 'graphicRecord',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'graphic_tab_setting',
        label: 'グラフィックレコーダ',
        icon: 'svguse:icons/graphic.svg#graphic',
        url: 'graphic-record'
      },
      {
        code: 'TrendGraph',
        isShow: false,
        isMenuDisplaySetting: true,
        // requirement: 'dataset_id_list',
        label: 'トレンドグラフ',
        icon: 'svguse:icons/ic_graph_trend.svg#ic_graph_trend',
        url: 'trend-graph',
      },
      {
        code: 'latestStatus',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: '最新値一覧',
        icon: 'svguse:icons/ic_status_normal.svg#ic_status_normal',
        url: 'latest-status',
      },
      {
        code: 'monitoringPreference',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: 'クラウド設定警報',
        icon: 'svguse:icons/setting-web.svg#setting-web',
        url: 'monitoring-preference',
      },
      // {
      //   code: 'longTrend',
      //   isShow: false,
      //   isMenuDisplaySetting: true,
      //   requirement: 'dataset_id_list',
      //   label: '長期トレンド',
      //   url: 'long-trend',
      //   icon: 'svguse:icons/ic_graph_long.svg#ic_graph_long',
      // },
      {
        code: 'basicInfo',
        isShow: true,
        isMenuDisplaySetting: false,
        label: '基本設定',
        icon: 'svguse:icons/information.svg#information',
        url: 'basic-info',
      },
      {
        // MainLayout.vue で専用設定を行う
        code: 'networkCamera',
        isShow: true,
        isMenuDisplaySetting: false,
        label: 'ネットワークカメラ',
        icon: 'svguse:icons/ic_network_camera.svg#ic_network_camera',
        url: null,
        isNewWindow: true
      },
    ]
  },
  {
    code: 'histories',
    isShow: false,
    isMenuDisplaySetting: true,
    label: '履歴・記録',
    icon: 'svguse:icons/ic_history_normal.svg#ic_history_normal',
    url: null,
    isDefaultOpenChildren: false,
    children: [
      {
        code: 'alarmHistory',
        isShow: false,
        isMenuDisplaySetting: true,
        label: '警報履歴',
        icon: 'svguse:icons/ic_history_normal.svg#ic_history_normal',
        url: 'alarm-history'
      },
      {
        code: 'operationHistory',
        isShow: false,
        isMenuDisplaySetting: true,
        label: '運転履歴',
        icon: 'svguse:icons/ic_history_normal.svg#ic_history_normal',
        url: 'operating-history'
      },
      {
        code: 'remoteControlHistory',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'gateway_list',
        label: '遠隔操作履歴',
        icon: 'svguse:icons/ic_history_normal.svg#ic_history_normal',
        url: 'remote-control-history'
      },
      {
        code: 'continuousTotalHistory',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: '連続時間積算履歴',
        icon: 'svguse:icons/ic_history_normal.svg#ic_history_normal',
        url: 'integration-timer-history'
      },
      {
        code: 'operatingSummary',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: '稼働状況',
        icon: 'svguse:icons/ic_operation_normal.svg#ic_operation_normal',
        url: 'operating-summary',
      },
      {
        code: 'chohyo',
        isShow: false,
        isMenuDisplaySetting: true,
        // requirement: 'dataset_id_list',
        label: '帳票',
        icon: 'svguse:icons/ic_chohyo.svg#ic_chohyo',
        url: 'chohyo'
      },
      {
        code: 'maintenanceHistory',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: 'シンプル記録',
        icon: 'svguse:icons/ic_history_normal.svg#ic_history_normal',
        url: 'maintenance-history'
      },
    ]
  },
  {
    code: 'datas',
    isShow: false,
    isMenuDisplaySetting: true,
    label: 'データ入出力',
    icon: 'svguse:icons/ic_download_normal.svg#Union',
    url: null,
    isDefaultOpenChildren: false,
    children: [
      {
        code: 'csvDownload',
        isShow: false,
        isMenuDisplaySetting: true,
        // requirement: 'dataset_id_list|children.dataset_id_list',
        label: '一括データ出力',
        icon: 'svguse:icons/ic_download_normal.svg#Union',
        url: 'csv-download',
      },
      {
        code: 'csvUpload',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: '一括データ入力',
        icon: 'svguse:icons/ic_upload.svg#ic_upload',
        url: 'csv-upload',
      },
      {
        code: 'documentManagement',
        isShow: false,
        isMenuDisplaySetting: true,
        label: 'ドキュメント管理',
        icon: 'folder',
        url: 'document-management'
      },
    ]
  },
  {
    code: 'report',
    isShow: false,
    isMenuDisplaySetting: true,
    label: '運転サポート',
    icon: 'svguse:icons/ic_report_normal.svg#Union',
    url: null,
    isDefaultOpenChildren: false,
    children: [
      {
        code: 'continuous_total',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: '連続時間積算',
        icon: 'svguse:icons/ic_addition.svg#ic_addition',
        url: 'integration-timer',
      },
      {
        code: 'technicalReport',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: 'テクニカルレポート',
        icon: 'svguse:icons/ic_report_normal.svg#Union',
        url: 'technical-report'
      },
      {
        code: 'mbrReport',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: 'MBR膜閉塞レポート',
        icon: 'svguse:icons/ic_report_normal.svg#Union',
        url: 'mbr-report'
      },
      {
        code: 'roReport',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: 'ROレポート',
        icon: 'svguse:icons/ic_report_normal.svg#Union',
        url: 'ro-report'
      },
      {
        code: 'Scatter',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'dataset_id_list',
        label: '統計データ分析',
        url: 'scatter',
        icon: 'svguse:icons/carbon_qq-plot.svg#qq-plot',
      },
    ]
  },
  {
    code: 'cameraSettings',
    isShow: false,
    isMenuDisplaySetting: true,
    requirement: 'camera_id_list',
    label: 'SaiIK',
    icon: 'svguse:icons/camera.svg#camera',
    url: null,
    isDefaultOpenChildren: false,
    children: [
      {
        code: 'cameraImage',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'camera_id_list',
        label: '画像・判別結果',
        icon: 'svguse:icons/ic_saiik_camera_result.svg#ic_saiik_camera_result',
        url: 'camera-image',
      },
      {
        code: 'cameraAiModelSettings',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'camera_id_list',
        label: 'モデル設定',
        icon: 'svguse:icons/ic_camera_model_setting.svg#camera_model_setting',
        url: 'camera-ai-model-setting'
      },
      {
        code: 'cameraAiModelDeploy',
        isShow: false,
        isMenuDisplaySetting: true,
        requirement: 'camera_id_list',
        permission: 'handleWriteC',
        label: 'デプロイ設定',
        icon: 'svguse:icons/ic_camera_model_setting.svg#camera_model_setting',
        url: 'camera-ai-model-deploy'
      },
    ]
  },
  {
    code: 'saicrewSetting',
    isShow: false,
    requirement: 'gateway_list',
    isMenuDisplaySetting: true,
    label: 'SaiCrew',
    icon: 'svguse:icons/ic_camera_model_setting.svg#camera_model_setting',
    url: null,
    isDefaultOpenChildren: false,
    children: [
      {
        code: 'saicrewAiModelSettings',
        isShow: false,
        requirement: 'gateway_list',
        label: 'モデル設定',
        url: 'saicrew-ai-model-setting',
        icon: 'svguse:icons/ic_camera_model_setting.svg#camera_model_setting',
        isMenuDisplaySetting: true,
      },
      {
        code: 'saicrewAiModelDeploy',
        isShow: false,
        requirement: 'gateway_list',
        permission: 'handleWriteC',
        label: 'デプロイ設定',
        url: 'saicrew-ai-model-deploy',
        icon: 'svguse:icons/ic_camera_model_setting.svg#camera_model_setting',
        isMenuDisplaySetting: true,
      },
    ]
  },
  {
    code: 'adminMenu',
    isShow: false,
    isMenuDisplaySetting: true,
    label: '管理メニュー',
    icon: 'svguse:icons/ic_setting_normal.svg#ic_setting_normal',
    url: null,
    children: [
      {
        code: 'adminUser',
        isShow: false,
        isMenuDisplaySetting: true,
        label: 'ユーザー管理',
        url: '/admin/user'
      },
      {
        code: 'adminNode',
        isShow: false,
        isMenuDisplaySetting: true,
        label: '階層管理',
        url: '/admin/node'
      },
      {
        code: 'adminPatlite',
        isShow: false,
        isMenuDisplaySetting: true,
        label: 'パトランプ管理',
        url: '/admin/patlite'
      },
      {
        code: 'adminNews',
        isShow: false,
        isMenuDisplaySetting: true,
        label: 'お知らせ管理',
        url: '/admin/news'
      },
      {
        code: 'adminAI',
        isShow: true,
        isMenuDisplaySetting: true,
        label: 'AI設定',
        url: null,
        children: [
          {
            code: 'adminDevice',
            isShow: true,
            isMenuDisplaySetting: true,
            label: 'デバイス管理',
            url: '/admin/device'
          },
          {
            code: 'adminCamera',
            isShow: true,
            isMenuDisplaySetting: true,
            label: 'カメラ管理',
            url: '/admin/camera'
          },
        ]
      },
      {
        code: 'adminGatewayIF',
        isShow: false,
        isMenuDisplaySetting: true,
        label: 'Gateway変換設定',
        url: '/admin/gateway-if'
      },
      {
        code: 'adminRecreateData',
        isShow: false,
        isMenuDisplaySetting: true,
        label: '逆転データ修復',
        url: '/admin/recreate-data'
      },
      {
        code: 'adminExportBi',
        isShow: false,
        isMenuDisplaySetting: true,
        label: '外部DB出力設定',
        url: '/admin/export-bi'
      },
    ]
  }
]
